module.exports = __webpack_public_path__ + "img/3_96.548c9df3.png";